import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { ContentLayout } from '../../../../components/ContentLayout';
import { FormFieldGroupLayout } from '../../../../components/FieldGroupLayout';
import { PhoneField } from '../../../../components/PhoneField';
import { sendSms } from '../../../../actions/registration';
import { changeView } from '../../../../actions/view';
import { isValidPhone } from '../../../../utils/validation';
import { phoneErrorSelector, hasPhoneErrorSelector, viewStateEmailSelector } from './selectors';
import { EKeyCode } from '../../../../types/keyCodes';
import { EActiveView } from '../../../../types/view';
import { ESentEmailType } from '../../../../types/sentEmail';
import { trackButtonClick } from '../../tracking';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var EnterPhoneNumberContainer = function EnterPhoneNumberContainer(_ref) {
  var useSelector = _ref.useSelector,
    useDispatch = _ref.useDispatch;
  var dispatch = useDispatch();
  var phoneError = useSelector(phoneErrorSelector);
  var hasAsyncPhoneError = useSelector(hasPhoneErrorSelector);
  var login = useSelector(viewStateEmailSelector);

  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    changed = _React$useState2[0],
    setChanged = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    touched = _React$useState4[0],
    setTouched = _React$useState4[1];

  // PHONE
  var phoneRef = React.useRef(null);
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    phone = _React$useState6[0],
    setPhone = _React$useState6[1];
  var isPhoneInvalid = React.useMemo(function () {
    return !isValidPhone(phone);
  }, [phone]);
  var handlePhoneChange = function handlePhoneChange(value) {
    setPhone(value);
    setChanged(true);
  };

  // SUBMITION
  var handleFocusInvalid = React.useCallback(function () {
    if (isPhoneInvalid && phoneRef.current) {
      phoneRef.current.focus();
      return;
    }
  }, [isPhoneInvalid]);
  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    trackButtonClick('continue');
    if (isPhoneInvalid) {
      handleFocusInvalid();
      return;
    }
    dispatch(sendSms({
      email: login,
      phone: phone
    }));
    setChanged(false);
  }, [isPhoneInvalid, sendSms]);
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  var handleSkipClick = React.useCallback(function () {
    trackButtonClick('add_later');
    dispatch(changeView(EActiveView.EmailSent, {
      type: ESentEmailType.Registration,
      email: login
    }));
  }, [changeView]);
  React.useEffect(function () {
    setPhone('');
  }, []);
  return /*#__PURE__*/_jsx(ContentLayout, {
    children: /*#__PURE__*/_jsx("form", {
      onSubmit: handlePreventSubmit,
      children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
        content: /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(PhoneField, {
            id: "tel",
            name: "tel",
            autoComplete: "tel",
            placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
            value: phone,
            inputRef: phoneRef,
            invalid: touched && (isPhoneInvalid || !changed && hasAsyncPhoneError),
            onValueChange: handlePhoneChange,
            onKeyDown: handleSubmitOnEnter,
            errorMessage: phoneError
          })
        }),
        buttons: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            "data-name": "ContinueAuthBtn",
            onClick: handleSubmit,
            fullWidth: true,
            children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"
          }), /*#__PURE__*/_jsx(Button, {
            "data-name": "SwitchToPhoneAuthBtn",
            theme: "fill_secondary",
            onClick: handleSkipClick,
            fullWidth: true,
            children: "\u0414\u043E\u0431\u0430\u0432\u043B\u044E \u043F\u043E\u0437\u0436\u0435"
          })]
        })
      })
    })
  });
};